module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('button', {
    staticClass: "fl-button",
    attrs: {
      "disabled": _vm.is_excel_export,
      "type": "button"
    },
    on: {
      "click": _vm.excelExport
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel"
  })])]), _vm._v(" "), _c('h1', [_vm._v("Átjáró Riport")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "element_type_id",
      "label": "Típus",
      "name": "element_type_id",
      "options": _vm.element_types
    },
    on: {
      "input": _vm.getElements
    },
    model: {
      value: (_vm.element_type_id),
      callback: function($$v) {
        _vm.element_type_id = $$v
      },
      expression: "element_type_id"
    }
  })], 1), _vm._v(" "), (_vm.elements.length > 0) ? _c('div', {
    staticClass: "col-xs-2"
  }, [_c('select2', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "label": "Eszköz",
      "name": "element_id",
      "id": "element_id",
      "options": _vm.elements
    },
    on: {
      "onChange": _vm.getItems
    },
    model: {
      value: (_vm.element_id),
      callback: function($$v) {
        _vm.element_id = $$v
      },
      expression: "element_id"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.element_id != 0),
      expression: "element_id != 0"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('h2', [_vm._v("Access Levels")]), _vm._v(" "), (_vm.accesslevels.length > 0) ? _c('div', [_c('table', {
    staticClass: "list"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.accesslevels), function(accesslevel) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(accesslevel.access_level))]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(accesslevel.allowed ? accesslevel.allowed : '-') + "\n                      "), (Object.keys(accesslevel.allowed_schedule).length) ? _c('ul', {
      staticClass: "small-buttons"
    }, [_c('li', [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "small-button-menu inline"
    }, [_c('div', {
      staticClass: "head"
    }, [_vm._v("Heti szabályok")]), _vm._v(" "), _vm._l((accesslevel.allowed_schedule), function(days, index) {
      return _c('ul', _vm._l((days), function(item) {
        return _c('li', [_vm._v(_vm._s(index) + ": " + _vm._s(item.start_time) + "-" + _vm._s(item.end_time))])
      }), 0)
    })], 2)])]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(accesslevel.denied ? accesslevel.denied : '-') + "\n                      "), (Object.keys(accesslevel.denied_schedule).length) ? _c('ul', {
      staticClass: "small-buttons"
    }, [_c('li', [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "small-button-menu inline"
    }, [_c('div', {
      staticClass: "head"
    }, [_vm._v("Heti szabályok")]), _vm._v(" "), _vm._l((accesslevel.denied_schedule), function(days, index) {
      return _c('ul', _vm._l((days), function(item) {
        return _c('li', [_vm._v(_vm._s(index) + ": " + _vm._s(item.start_time) + "-" + _vm._s(item.end_time))])
      }), 0)
    })], 2)])]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(accesslevel.active_cards))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.accesslevels_sumcards))])])])])])]) : _c('div', [_vm._v("\n                Nincs találat.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h2', [_vm._v("Heti nyitvatartás")]), _vm._v(" "), (_vm.openings.length > 0) ? _c('div', [_c('table', {
    staticClass: "list"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.openings), function(opening) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(opening.day_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opening.open))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opening.close))])])
  }), 0)])]) : _c('div', [_vm._v("\n                Nincs találat.\n              ")]), _vm._v(" "), _c('h2', [_vm._v("Jövőbeli rendhagyó nyitvatartás")]), _vm._v(" "), (_vm.opening_spec_days.length > 0) ? _c('div', [_c('table', {
    staticClass: "list"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.opening_spec_days), function(opening_spec_day) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(opening_spec_day.date_from))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opening_spec_day.date_to))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opening_spec_day.time_from))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opening_spec_day.time_to))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opening_spec_day.close ? "Zárva" : "Nyitva"))])])
  }), 0)])]) : _c('div', [_vm._v("\n                Nincs találat.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', [_vm._v("Jövőbeli rendhagyó jogosultságú dátumok")]), _vm._v(" "), (_vm.spec_days.length > 0) ? _c('div', [_c('table', {
    staticClass: "list"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.spec_days), function(spec_day) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(spec_day.name))]), _vm._v(" "), _c('td', [_c('ul', {
      staticStyle: {
        "padding": "0"
      }
    }, _vm._l((spec_day.access_levels), function(spec_day_access_level) {
      return _c('li', {
        staticStyle: {
          "list-style-type": "none"
        }
      }, [_vm._v(_vm._s(spec_day_access_level))])
    }), 0)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(spec_day.start_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(spec_day.end_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(spec_day.start_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(spec_day.end_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(spec_day.operation))])])
  }), 0)])]) : _c('div', [_vm._v("\n                  Nincs találat.\n                ")])])])])])])], 1), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_excel_export
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Név")]), _vm._v(" "), _c('th', [_vm._v("Engedélyezve")]), _vm._v(" "), _c('th', [_vm._v("Tiltva")]), _vm._v(" "), _c('th', [_vm._v("Aktív kártyák")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "small-button inline with-menu",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "small-button inline with-menu",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', [_vm._v("Egyéni jogosultságok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nap")]), _vm._v(" "), _c('th', [_vm._v("Nyitás")]), _vm._v(" "), _c('th', [_vm._v("Zárás")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Kezdő dátum")]), _vm._v(" "), _c('th', [_vm._v("Vég dátum")]), _vm._v(" "), _c('th', [_vm._v("Időponttól")]), _vm._v(" "), _c('th', [_vm._v("Időpotig")]), _vm._v(" "), _c('th', [_vm._v("Szabály")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Megnevezés")]), _vm._v(" "), _c('th', [_vm._v("Access Levels")]), _vm._v(" "), _c('th', [_vm._v("Kezdő dátum")]), _vm._v(" "), _c('th', [_vm._v("Vég dátum")]), _vm._v(" "), _c('th', [_vm._v("Időponttől")]), _vm._v(" "), _c('th', [_vm._v("Időpontig")]), _vm._v(" "), _c('th', [_vm._v("Szabály")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-642a2f00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/report.vue
// module id = 308
// module chunks = 0